/** What everyone has until they change something: labels on (plain-text controls for mixed digital confidence). */
export const DEFAULT_PERSON_PREFS = { showButtonLabels: true };
//# sourceMappingURL=prefs.js.map